<!-- 搜索部门树弹窗： 1.学分统计：选择工作单位；2.培训选调：选择选调范围 -->
<template>
  <el-dialog
    title="选择工作单位"
    class="rc-dialog"
    :visible.sync="deptDialog.flag"
    :close-on-click-modal="false"
    :destroy-on-close="false"
    width="40%"
  >
    <el-input
      class="search-dept"
      prefix-icon="el-icon-search"
      v-model.trim="searchName"
      @change="searchDep"
      size="small"
      placeholder="请输入部门名称"
    />
    <el-checkbox class="checkbox_style" v-model="checkAll" @change="handleCheckAll" v-if="!searchName">全选</el-checkbox>
    <el-tree
      lazy
      ref="tree"
      :data="treeData"
      :props="props"
      show-checkbox
      class="dept-tree"
      :default-checked-keys="defaultCheckedKeys"
      :expand-on-click-node="false"
      check-on-click-node
      node-key="uuid"
      @check-change="handleCheckChange"
      :load="loadNode"
    >
    </el-tree>
    <span slot="footer" class="dialog-footer">
      <butn
        class="czButn"
        @click="deptDialog.flag = false"
        size="small"
        title="取 消"
      />
      <butn
        btntype="primary"
        @click="didSelectDept"
        size="small"
        title="确 定"
      />
    </span>
  </el-dialog>
</template>

<script>
import butn from "@/components/button/index";
import { deptTreeNew } from "@/api/dept";
import { throttle, filterLevelCode } from "@/utils/common.js";

export default {
  components: { butn },
  props: {
    deptDialog: {
      type: Object,
      default: () => {
        return {
          flag: false,
        };
      },
    },
    defaultCheckedKeys: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      searchName: "",
      treeData: [],
      checkAll: false,
      flatTreeList: [],
      props: {
        //树形
        label: "deptName",
        children: "zones",
        isLeaf: function(data, node) {
          return !data.hasChildren
        },
      },
    };
  },
  methods: {
    // 加载节点
    loadNode(node, resolve) {
      let params = {};
      if (node.data && node.data.uuid) {
        params.parentId = node.data.uuid;
      }
      deptTreeNew(params).then(({ code, data }) => {
        if (code !== 0) return;
        this.flatTreeList = this.flatTreeList.concat(data);
        resolve(data);
      });
    },
    handleCheckAll(val) {
      if (val) {
        this.$refs.tree.setCheckedNodes(this.flatTreeList);
      } else {
        this.$refs.tree.setCheckedNodes([]);
      }
    },
    listenCheckAll() {
      let temp = this.$refs.tree.getCheckedNodes();
      this.checkAll = temp.length == this.flatTreeList.length ? true : false;
    },
    // 搜索过滤部门树
    searchDep(val) {
      this.treeData = [];
      let params = {
        deptName: val
      }
      deptTreeNew(params).then(({ code, data }) => {
        if (code !== 0) return;
        this.treeData = data;
      });
    },
    handleCheckChange: throttle(function () {
      this.listenCheckAll();
    }, 200),
    // 选择组织后请求角色数据
    didSelectDept() {
      const nodes = this.$refs["tree"].getCheckedNodes();
      const nodeKeys = this.$refs["tree"].getCheckedKeys();
      // 获取deptLevelCodes
      let deptLevelCodes = nodes.map(x => x.deptLevelCode);
      let deptParentCodes = filterLevelCode(deptLevelCodes);
      if (nodes.length > 0) {
        let deptNames = nodes.map((item) => item.deptName);
        this.$parent.deptNames = deptNames.join("、"); 
      } else {
        this.$parent.deptNames = "";
      }
      this.$emit("selectDept", { deptLevelCodes: deptParentCodes, nodeKeys: nodeKeys });
    },
  }
}

</script>

<style lang="scss" scoped>
.checkbox_style {
  margin: 6px 0;
  margin-left: 24px;
}
</style>